import { render, staticRenderFns } from "./DaysTrafficRefactored.vue?vue&type=template&id=23811d10&"
import script from "./DaysTrafficRefactored.vue?vue&type=script&lang=js&"
export * from "./DaysTrafficRefactored.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports